import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges }      from '@angular/core';
import { PlainDropdownComponent } from '../shared/plain-dropdown/plain-dropdown.component';
import { DropdownFilterOptions } from '../models/analytics/dropdown-filter-options';
import { DropdownFilterOption } from '../models/analytics/dropdown-filter-option';
import { ResProgFilter } from '../models/analytics/resProgFilter';

@Component({
  selector: 'app-date-select',
  templateUrl: './date-select.component.html',
  styleUrls: ['./date-select.component.less']
})
export class DateSelectComponent implements OnInit, OnChanges {
  @Input() filterInitialValue: number;
  @Output() dateFilterChanged: EventEmitter<any> = new EventEmitter();
  public isActive: number;
  private currentLiveFilter: DropdownFilterOption;
  @Input() enablePerUserToggle: string = null;
  @Input() enableLiveFilter: boolean = false;
  @Input() enableResProgSelect: boolean = false;
  @Input() enableResProgCommSelect: boolean = false;
  @Input() liveFilter: string = 'live';
  @Input() resProgFilter: ResProgFilter;
  @Input() liveFilterOptions: DropdownFilterOptions;
  @Output() liveFilterAltered: EventEmitter<string> = new EventEmitter<string>();
  @Output() resProgFilterChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() perUser: boolean = false;
  @Output() perUserChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('liveFilterDropdown') liveFilterDropdown: PlainDropdownComponent;
  @ViewChild('resProgDropdown') resProgDropdown: PlainDropdownComponent;
  @ViewChild('resProgCommDropdown') resProgCommDropdown: PlainDropdownComponent;
  @ViewChild('perUserDropdown') perUserDropdown: PlainDropdownComponent;

  public dateFilterClicked(filterNo: number) {
    this.dateFilterChanged.emit(filterNo);
    this.isActive = filterNo;
  }

  public ngOnInit() {
    this.isActive = this.filterInitialValue;
  }

  ngOnChanges() {
    if (this.liveFilterOptions) {
      this.liveFilterOptions.forEach(liveFilterOption => {
        if (liveFilterOption.ref === this.liveFilter) {
          this.currentLiveFilter = liveFilterOption;
        }
      });
    }
  }

  private setLiveFilter(liveFilter: any) {
    this.currentLiveFilter = liveFilter;
    this.liveFilter = liveFilter.ref;
    this.liveFilterAltered.emit(this.liveFilter);
    this.liveFilterDropdown.close();
  }

  private setResProg(resProg: any) {
    this.resProgFilter = resProg;
    this.resProgFilterChange.emit(resProg);
    if (this.enableResProgSelect) {
      this.resProgDropdown.close();
    } else if (this.enableResProgCommSelect) {
      this.resProgCommDropdown.close();
    }
  }

  private setPerUser(liveFilter: boolean) {
    this.perUser = liveFilter;
    this.perUserChange.emit(liveFilter);
    this.perUserDropdown.close();
  }

  private getResProgName(resProg: string) {
    if (resProg === 'resProgComm') {
      return 'Programs, Resources & Community'
    } else if (resProg === 'resProg') {
      return 'Programs & Resources'
    } else {
      return resProg
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/analytics/date-select.component.ts